import matter from 'gray-matter';

// Parse markdown content with frontmatter
const parseMarkdown = (content) => {
  const { data, content: body } = matter(content);
  return { data, body };
};

// Load content from markdown files
export const loadContent = async (path) => {
  try {
    const response = await fetch(`/content/${path}`);
    if (!response.ok) {
      console.warn(`Content file not found: ${path}`);
      return null;
    }
    const content = await response.text();
    return parseMarkdown(content);
  } catch (error) {
    console.error('Error loading content:', error);
    return null;
  }
};

// Load multiple files from a directory
export const loadContentCollection = async (collection) => {
  try {
    // In a real implementation, you'd have a manifest or API
    // For now, we'll return empty array and implement as needed
    return [];
  } catch (error) {
    console.error(`Error loading ${collection} collection:`, error);
    return [];
  }
};

// Specific content loaders with fallbacks
export const getSettings = async () => {
  const content = await loadContent('settings.md');
  if (!content) {
    // Fallback settings
    return {
      data: {
        title: 'JXLES Studio',
        maintenance_mode: false,
        social_links: {
          instagram: '',
          spotify: '',
          soundcloud: '',
          twitter: '',
          youtube: '',
          bandcamp: ''
        }
      },
      body: ''
    };
  }
  return content;
};

export const getAbout = async () => {
  const content = await loadContent('about.md');
  if (!content) {
    // Fallback about content
    return {
      data: {
        title: 'About',
        bio: 'Welcome to my music world.',
        achievements: []
      },
      body: ''
    };
  }
  return content;
};

// Helper function to check maintenance mode with fallback
export const isMaintenanceMode = async () => {
  try {
    const settings = await getSettings();
    return settings?.data?.maintenance_mode || false;
  } catch (error) {
    console.error('Error checking maintenance mode:', error);
    return false; // Safe fallback
  }
};
